// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","selectList__name":"SelectList_selectList__name__9YN61"};